import RecentActorsIcon from "@material-ui/icons/RecentActors";
import { IRoute } from "src/common/typings/routes";
import { CompanyProfileModule } from "./companyProfileModule";
import { CompanyProfile } from "./pages/CPDetails";

export const CompanyProfileRoute: IRoute = {
  title: "Company Profile",
  path: "/company-profile",
  icon: RecentActorsIcon,
  component: CompanyProfileModule,
  subRoutes: [
    {
      component: CompanyProfile,
      path: "/details",
      title: "Company Profile",
    },
  ],
};
